export default function PHP_ReferenceTimezones() {
  return (
    <div>
      <h1>PHP_ReferenceTimezones</h1>
    </div>
  );
}
